import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-maine-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./maine-state-form.component.html",
  styleUrl: "./maine-state-form.component.scss",
})
export class MaineStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
